export { default } from './BrotherCollaborationView';



// WEBPACK FOOTER //
// ./src/components/views/BrotherCollaborationView/index.js